<style lang="scss" scoped>
@import 'common/sass/reuse.SCSS';
.function {
  padding: 20px 20px 0px;
}
</style>

<template>
  <div class="maintenance-box">
    <div class="panel" v-loading="loading">
      <el-row :gutter="20" class="function">
        <el-col :xs="4" :sm="4" :md="4" :lg="4" :xl="4">
            <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6" style="padding: 10px 0 0 0">{{ language.topTxt }}</el-col>
            <el-col :xs="18" :sm="18" :md="18" :lg="18" :xl="18" style="padding: 0">
                <el-input v-model="formData.topValue"></el-input>
            </el-col>
        </el-col>
        <el-col :xs="4" :sm="4" :md="4" :lg="4" :xl="4">
            <el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8" style="padding: 10px 0 0 0">{{ language.profitTypeTxt }}</el-col>
            <el-col :xs="16" :sm="16" :md="16" :lg="16" :xl="16" style="padding: 0">
                <el-select v-model="formData.profitType" @change="profitTypeChange">
                    <template v-for="(k,v) in language.profitType">
                        <el-option :label="k" :value="v" :key="v"></el-option>
                    </template>
                </el-select>
            </el-col>
        </el-col>
        <el-col :xs="5" :sm="5" :md="5" :lg="5" :xl="5">
          <el-date-picker 
            :end-placeholder="language.endTime"
            :picker-options="pickerOptions"
            :start-placeholder="language.startTime"
            style="width: 100%" 
            type="daterange" 
            @blur="blurHandle"
            v-model="formData.dateRange"
            value-format="yyyy-MM-dd"
          ></el-date-picker>
        </el-col>
        <el-col :xs="2" :sm="2" :md="2" :lg="2" :xl="2">
            <el-button @click="ajaxHandle" type="primary" style="width: 100%" v-text="language.searchTxt"></el-button>
        </el-col>
        <el-col :xs="4" :sm="4" :md="4" :lg="4" :xl="4">
            <el-button @click="export2Excel(tbodyData, language.excelName)" style="width: 100%" v-text="language.downloadTxt"></el-button>
        </el-col>
      </el-row>
      <el-row>
        <custom-table :changeHeight="true" :pageEnable="false" :tableHead="tableHead" :tbodyData="tbodyData"></custom-table>
      </el-row>
    </div>
  </div>
</template>

<script>
import customTable from 'components/reuseTable'
import { URL_PROFIT_TOP_LIST } from 'api/api'
import { 
    enableMondayAndFriday, 
    enableMondayAndFridayOnPick, 
    enableFirstAndLastDayOfMonth,
    enableFirstAndLastDayOfMonthOnPick,
    enableUntilToday,
    enableUntilTodayOnPick
} from 'common/js/util'

const data = () => {
    return {
        tbodyData: [],
        loading: false,
        formData: {
            dateRange: [],
            topValue: 30,
            profitType: 'weekly'
        },
        pickerOptions: {
            disabledDate: enableMondayAndFriday,
            onPick: enableMondayAndFridayOnPick
        },
        disabledDateFunc: {
            'weekly': enableMondayAndFriday,
            'monthly': enableFirstAndLastDayOfMonth,
            'daily': enableUntilToday
        },
        onPickFunc: {
            'weekly': enableMondayAndFridayOnPick,
            'monthly': enableFirstAndLastDayOfMonthOnPick,
            'daily': enableUntilTodayOnPick
        }
    }
}

const mixins = [
    require('common/mixin/base').base({ language: 'profitTopList' }), 
    require('common/mixin/base').base({ reuse: 'reuse' })
]

const computed = {
    tableHead() {
        const columns = this.language[this.formData.profitType] || [];
        columns.forEach(head => head.redColor = true)
        const tableHead = this.language.tableHead || [];
        return [...tableHead, ...columns];
    },
}

const created = function () {
    this.defaultWeeklyDate()
    this.ajaxHandle()
}

const methods = {
    ajaxHandle() {
        this.loading = true
        this.$http.post(URL_PROFIT_TOP_LIST, this.formData).then((res) => {
            const useful = res.data.data
            if (Object.prototype.toString.call(useful.data) === '[object Array]') {
                this.tbodyData = useful.data
                this.tbodyData.forEach(v => {
                    v.LOGIN = `${v.LOGIN || ''}`
                    v.IB_ID = `${v.IB_ID || ''}`
                })
            } else {
                this.tbodyData = []
            }
            this.loading = false
        }).catch((e) => {
            alert(this.reuse.serverError)
        })
    },
    export2Excel(datas, excelName) {
        require.ensure([], () => {
            const { export_json_to_excel } = require('@/vendor/Export2Excel')
            const tHeader = this.tableHead.map((v) => v.value)
            const filterVal = this.tableHead.map((v) => v.key)
            const data = datas.map((v) => filterVal.map((j) => v[j]))
            const reportType = this.language.profitType[this.formData.profitType]
            const reportDate = this.formData.dateRange.map(v => this.$moment(v).format('YYYY-MM-DD').replace(/-/g, '')).join('-')
            const name = `${excelName}_${reportType}_${reportDate}`
            export_json_to_excel(tHeader, data, name, { moneyStyle: '#,##0.00;[Red](#,##0.00)' })
        })
    },
    profitTypeChange(profitType) {
        this.pickerOptions.disabledDate = this.disabledDateFunc[profitType]
        this.pickerOptions.onPick = this.onPickFunc[profitType]
        const defaultFunc = {'weekly': 'defaultWeeklyDate', 'monthly': 'defaultMonthlyDate', 'daily': 'defaultDailyDate'}
        this[defaultFunc[profitType]]()
        this.ajaxHandle();
    },
    blurHandle(obj) {
        const { profitType } = this.formData
        this.pickerOptions = {
            disabledDate: this.disabledDateFunc[profitType],
            onPick: this.onPickFunc[profitType]
        }
    },
    defaultWeeklyDate() {
        const weekDay = this.$moment().weekday()
        const startDays = [1, 2, 3, 4, 5].includes(weekDay) ? (6 + weekDay) : (weekDay === 6 ? 5 : 6)
        const endDays = startDays - 4
        const startDate = this.$moment().subtract(startDays, 'd').format('YYYY-MM-DD')
        const endDate = this.$moment().subtract(endDays, 'd').format('YYYY-MM-DD')
        this.formData.dateRange = [startDate, endDate]
    },
    defaultMonthlyDate() {
        const lastMonth = this.$moment().subtract(1,'months')
        const startDate = lastMonth.date(1).format('YYYY-MM-DD')
        const endDate = lastMonth.endOf('month').format('YYYY-MM-DD')
        this.formData.dateRange = [startDate, endDate]
    },
    defaultDailyDate() {
        const weekday = this.$moment().weekday();
        const index = [6, 0, 1].indexOf(weekday) + 1;
        const subCount = index > 0 ? index : 1;
        const yesterday = this.$moment().subtract(subCount, 'd').format('YYYY-MM-DD')
        this.formData.dateRange = [yesterday, yesterday]
    }
}

const components = {
    customTable,
}

export default {
    data,
    mixins,
    computed,
    created,
    methods,
    components,
}
</script>


// WEBPACK FOOTER //
// src/views/manager-report/profit-top-list.vue